import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import WhyAnonymousBidding from "@/components/landing/WhyAnonymousBidding";
import HowItWorks from "@/components/landing/HowItWorks";
import Intelligence from "@/components/landing/Intelligence";
import WhyCommodityBid from "@/components/landing/WhyCommodityBid";
import Integration from "@/components/landing/Integration";
import Outcomes from "@/components/landing/Outcomes";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function CommodityBid() {
  return (
    <div data-testid="commoditybid-landing" className="min-h-screen bg-white font-body text-[#0B1F3A] antialiased">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <WhyAnonymousBidding />
        <HowItWorks />
        <Intelligence />
        <WhyCommodityBid />
        <Integration />
        <Outcomes />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
